// import React, { useState } from "react";
// import Header from "./common/header-component/header";
// import SidebarView from "./common/sidebar-component/sidebar";
// import RightSidebar from "./common/right-sidebar";
// import Footer from "./common/footer";
// import ThemeCustomizer from "./common/theme-customizer";
// import { ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import Loader from "./common/loader";

// const AppLayout = ({ children }) => {
//   const { innerWidth: width, innerHeight: height } = window;
//   console.log({ hase: window.location.hash }, "window");
//   var isVisible = window.location.hash.includes("/enrolled-exam");
//   console.log({ isVisible }, "window");
//   return (
//     <div style={{ fontFamily: "proxima" }}>
//       <Loader />
//       <div className="page-wrapper">
//         <div className="page-body-wrapper">
//           {!isVisible && <Header />}
//           {!isVisible && <SidebarView />}
//           <RightSidebar />
//           {/* <RightSidebar /> */}
//           <div className={!isVisible ? "page-body" : " page-body m-t-0"}>
//             {children}
//           </div>
//           {!isVisible && <Footer />}
//           {/* <ThemeCustomizer /> */}
//         </div>
//       </div>
//       <ToastContainer />
//     </div>
//   );
// };

// export default AppLayout;



// import React, { useState } from "react";
// import Header from "./common/header-component/header";
// import SidebarView from "./common/sidebar-component/sidebar";
// import RightSidebar from "./common/right-sidebar";
// import Footer from "./common/footer";
// import { ToastContainer } from "react-toastify";
// import Loader from "./common/loader";
// import "./dashboard.css"

// const AppLayout = ({ children }) => {
//   const [sidebarOpen, setSidebarOpen] = useState(false);

//   const toggleSidebar = () => {
//     setSidebarOpen(prev => !prev);
//   };

//   return (
//     <div className={`dashboard-layout ${sidebarOpen ? "sidebar-open" : ""}`}>
//       <Loader />

//       <div className="page-wrapper">
//         <Header onToggleSidebar={toggleSidebar} />

//         <div className="page-body-wrapper">
//           <SidebarView sidebarOpen={sidebarOpen} />

//           <div className="page-body">
//             {children}
//           </div>

//           <RightSidebar />
//         </div>

//         <Footer />
//       </div>

//       <ToastContainer />
//     </div>
//   );
// };

// export default AppLayout;


import Header from "./common/header-component/header"
import SidebarView from "./common/sidebar-component/sidebar"
import Footer from "./common/footer"

const AppLayout = ({ children }) => {
  return (
    <div style={{ display: "flex", height: "100vh" }}>

      {/* Sidebar (fixed, no scroll) */}
      <div>
        <SidebarView />
      </div>

      {/* Main Layout (THIS scrolls) */}
      <div
        style={{
          flex: 1,
          height: "100vh",
          overflowY: "auto",
          background: "hsla(0,0%,96.5%,.6)"
        }}
      >
        {/* Sticky Header */}
        <div
          style={{
            position: "sticky",
            top: 0,
            zIndex: 100,
            background: "#fff",
          }}
        >
          <Header />
        </div>

        {/* Page Content */}
        <div>
          <div style={{ padding: "16px", marginBottom:"100px" }}>
            {children}
          </div>

          {/*** Footer ****/}
          <div>
            <Footer />
          </div>
        </div>

      </div>
    </div>
  );
};

export default AppLayout;

